import update from 'immutability-helper'
import React, {useContext} from 'react'
import {useHistory, Link} from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import DialogContentText from '@mui/material/DialogContentText'

import TextInput from 'components/text-input'
import Dialog from 'components/responsive-fullscreen-dialog'
import create, {createPost} from 'helpers/command'
import {TeacherContext} from 'teacher/context'

export default function AssignmentRowSettings ({context, assignment, classes}) {

  const history = useHistory()
  const {translate} = context
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [deleteOpened, openDeleteAssignment] = React.useState(false)

  const openRowSettingsMenu = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const closeRowSettingsMenu = (e, reason) => {
    setAnchorEl(null)
  }

  function handleOpenDelete() {
    closeRowSettingsMenu()
    openDeleteAssignment(true)
  }

  async function handleDelete(confirmed) {
    openDeleteAssignment(false)
    if (confirmed) {
      const canModify = await context.validateStatus(assignment);
      if (canModify) {
        const [deletedId] = await create('quiz', 'deleteAssignment')({id: assignment.id})
        if (deletedId == assignment.id) {
          if (context.query.id) context.navigate({}, undefined, {query: {...context.query, id: undefined}})
          else context.setState({quizAssignmentCalls: context.quizAssignmentCalls + 1})
        }
      }
    }
  }

  function handleOpenReassign() {
    context.setState({quizAssignmentToReassign: assignment})
    closeRowSettingsMenu()
  }

  function handlePublishAll() {
    if (context.quizStudentAssessments.length > 0) {
      context.updateState({quizStudentAssessments: {$apply: s => s.map(a => update(a, {properties: {published: {$set: true}}}))}})
      create('quiz','publishAllReviewed')({id: assignment.id})
    }
    closeRowSettingsMenu()
  }

  async function handlePrintBlankAssessmentPdf () {
    closeRowSettingsMenu()
    await create('quiz', 'startTestAssessment')({id: assignment.assessment})
    context.updateState({quizBlankAssessmentForPdfId: {$set: assignment.assessment}})
  }

  const canPublish = assignment.id == context.assignmentId && context.quizStudentAssessments.findIndex(a => {
    const results = Object.values(a.results || {})
    return results.every(r => !r.pending)
  }) >= 0

  return (
    <Box className={classes.moreSettings}>
      <Box className={classes.moreSettingsButton} onClick={openRowSettingsMenu}>
        <MoreVertIcon />
      </Box>
        <Menu
          id="settings-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={closeRowSettingsMenu}
        >
          {assignment.startedCount < 1 && <MenuItem onClick={handleOpenDelete}>{context.translate('delete')}</MenuItem>}
          {assignment.startedCount > 0 && <MenuItem onClick={handleOpenReassign}>{context.translate('reassign')}</MenuItem>}
          {canPublish > 0 && <MenuItem onClick={handlePublishAll}>{context.translate('publish-all')}</MenuItem>}
          <MenuItem onClick={handlePrintBlankAssessmentPdf}>{context.translate('blank-assessment-pdf')}</MenuItem>
        </Menu>
      <Dialog
        open={deleteOpened}
        close={handleDelete}
        confirm={<Button variant="contained" color="primary" onClick={() => handleDelete(true)}>{translate('delete')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={() => handleDelete()}>{translate('cancel')}</Button>}
        title={translate('confirm_delete_item')}
      >
        <DialogContentText>
          {translate('delete-assignment-message', assignment)}
        </DialogContentText>
      </Dialog>
    </Box>
  )
}
